var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstudiante6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 94,
    viewBox: "0 0 57 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60001 73.57L19.72 62.94V32.56L1.60001 43.19V73.57Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.389999 44.29L1.6 44.98V73.57L0.389999 72.98V44.29Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.58 71.04L39.54 61.18V41.91L22.58 51.77V71.04Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    fill: "#EAEAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.65 82.75L56.61 72.89V53.62L39.65 63.48V82.75Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 51.7L39.54 41.84L22.58 51.7L39.65 61.56L56.61 51.7Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.21 48.22C48.21 47.56 48.21 46.95 48.14 46.37C49.3878 44.3346 50.1318 42.0308 50.31 39.65C50.31 35.12 49.75 29.37 47.79 25.52C47.696 25.316 47.5821 25.1217 47.45 24.94C47.3291 24.5534 47.1042 24.2075 46.8 23.94C44.9872 22.7385 43.0408 21.7518 41 21C37.45 19.56 33.62 18.79 32.15 22.33C31.02 24.71 29.68 32.76 29.68 32.76C27.3201 35.0481 24.7486 37.1073 22 38.91L25.18 40.91C27.6693 39.7486 30.0604 38.3875 32.33 36.84C32.6253 37.9995 32.6899 39.2057 32.52 40.39L33.75 43.12C19.75 49.96 17.83 52.27 20.75 73.33L24.47 75.4C25.47 65.34 25.6 61.54 29.84 57.84C28.54 62.69 28.97 68.94 29.84 78.31L33.56 80.38C37.56 64.32 37.9 62.38 42.86 58.77C46.46 56.15 48.54 52.82 48.25 48.44C48.2443 48.3655 48.2309 48.2918 48.21 48.22Z",
    fill: "#252525",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 78.27C21.8 82.27 25.94 87.97 33.52 80.34L29.8 78.27Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 15.92C39.75 15.92 34.8 16 35 14C35.2 12 34.26 11 36 8.82C36.7 8.01003 37.6273 7.42915 38.6616 7.15275C39.6958 6.87636 40.7893 6.91721 41.8 7.27C43.7 7.88 45.88 9.67 45.57 14.01C45.3836 16.667 45.7234 19.3346 46.57 21.86C47.16 23.38 46.8 23.98 46.8 23.98C46.4069 23.6474 45.919 23.4472 45.4056 23.4077C44.8922 23.3682 44.3794 23.4915 43.94 23.76C41.88 24.98 42.57 29.76 39.82 31.54C37.07 33.32 32.66 31.46 32.05 29.16C31.44 26.86 32.74 24.47 34.22 22.48C35.0634 21.5121 35.5473 20.2831 35.59 19L39.75 15.92Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.88 18.25C35.48 20.13 36.44 20.63 37.71 20.72C39.65 20.87 40.8 18.5 40.95 16.49C41.1 14.48 41.07 14.91 41.07 14.91C41.0156 14.0785 40.6942 13.2868 40.1537 12.6526C39.6132 12.0184 38.8824 11.5755 38.07 11.39C35.17 10.39 35.07 12.17 35.07 12.17C34.83 13.22 34.49 17 34.88 18.25Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.11 11.39C36.03 10.69 35.28 11.56 35.11 11.9L34.93 13.46C35.27 12.36 38.93 12.36 41.12 14.91C41.065 14.0771 40.7421 13.2844 40.1997 12.65C39.6572 12.0157 38.9242 11.5737 38.11 11.39Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.57 50.38C46.45 58.38 50.96 55.52 50.21 50.72L47.57 50.38Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.389999 42.53V44.29L33.18 63.16L51.3 52.54",
    fill: "#DEDEDE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.389999 42.53V44.29L33.18 63.16L51.3 52.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L51.3 82.92V52.54L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 50.78L18.52 31.91L0.389999 42.53L33.18 61.41L51.3 50.78Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L31.98 92.94V62.56L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.45 47.26L26.81 54.66L18.19 49.72L30.83 42.31L39.45 47.26Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.21 41.27L17.57 48.68L8.96001 43.73L21.6 36.33L30.21 41.27Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 73.29C11.68 78.04 17.42 81.59 24.47 75.36L20.75 73.29Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.27 49.57C36.27 51.9 39.94 57.57 44.46 51.57L41.27 49.57Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22 38.91C15.93 40.8 19.61 44.91 25.18 40.91L22 38.91Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3 38.71C50.6 44.66 44.46 51.53 44.46 51.53L41.27 49.53C41.27 49.53 44.91 42.44 45.57 39.91C45.93 38.49 43.46 32.52 43.46 32.52",
    fill: "#252525"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3 38.71C50.6 44.66 44.46 51.53 44.46 51.53L41.27 49.53C41.27 49.53 44.91 42.44 45.57 39.91C45.93 38.49 43.46 32.52 43.46 32.52",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.35 37.41C29.4408 38.8364 27.3488 40.0001 25.13 40.87L21.95 38.87C24.7307 37.0657 27.3326 34.9996 29.72 32.7",
    fill: "#252525"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.35 37.41C29.4408 38.8364 27.3488 40.0001 25.13 40.87L21.95 38.87C24.7307 37.0657 27.3326 34.9996 29.72 32.7",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.49 24.35C31.18 25.27 30.33 31.35 31.23 32.74C32.3017 34.5468 32.7645 36.6502 32.55 38.74",
    fill: "#252525"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.49 24.35C31.18 25.27 30.33 31.35 31.23 32.74C32.3017 34.5468 32.7645 36.6502 32.55 38.74",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstudiante6);
export default __webpack_public_path__ + "static/media/Estudiante6.b7d713595da2d46248e3e86963919c49.svg";
export { ForwardRef as ReactComponent };